var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "1200px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(_setup.LanguageRadioButtons, {
            staticStyle: { "margin-bottom": "10px" },
            attrs: { value: _setup.currentLang, options: _setup.langOptions },
            on: { input: _setup.handleLangInput },
          }),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localFormData,
                rules: _setup.formRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "问题标题", prop: "title" } },
                _vm._l(_setup.langOptions, function (opt) {
                  return _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: opt.value === _setup.currentLang,
                        expression: "opt.value === currentLang",
                      },
                    ],
                    key: opt.value,
                    attrs: {
                      placeholder: "请输入问题标题",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _setup.localFormData.title[opt.value],
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData.title, opt.value, $$v)
                      },
                      expression: "localFormData.title[opt.value]",
                    },
                  })
                }),
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticClass: "sort-input",
                    attrs: { min: 0, max: 9999, "controls-position": "right" },
                    model: {
                      value: _setup.localFormData.sort,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "sort", $$v)
                      },
                      expression: "localFormData.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属问题分类", prop: "type_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择问题分类" },
                      model: {
                        value: _setup.localFormData.type_id,
                        callback: function ($$v) {
                          _vm.$set(_setup.localFormData, "type_id", $$v)
                        },
                        expression: "localFormData.type_id",
                      },
                    },
                    _vm._l(_setup.categoryOptionsForLang, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否热门问题", prop: "is_hot" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localFormData.is_hot,
                        callback: function ($$v) {
                          _vm.$set(_setup.localFormData, "is_hot", $$v)
                        },
                        expression: "localFormData.is_hot",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localFormData.status,
                        callback: function ($$v) {
                          _vm.$set(_setup.localFormData, "status", $$v)
                        },
                        expression: "localFormData.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("停用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "问题内容", prop: "content" } },
                _vm._l(_setup.langOptions, function (opt) {
                  return _vm.visible
                    ? _c(_setup.Tinymce, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: opt.value === _setup.currentLang,
                            expression: "opt.value === currentLang",
                          },
                        ],
                        key: `faq-q-content-${opt.value}-${_setup.tinymceKey}`,
                        attrs: {
                          value: _setup.localFormData.content[opt.value],
                          height: 260,
                          language: "zh",
                        },
                        on: {
                          input: (val) =>
                            (_setup.localFormData.content[opt.value] = val),
                        },
                      })
                    : _vm._e()
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }